// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"e07ab2a4","654":"ba3a96da"}[chunkId] + ".chunk.js";
};